import api from "./client";

// --- Get all array-module relations ---
export const listArrayModules = async () => {
  const { data } = await api.get("/arraymodules/");
  return data;
};

// --- Get array-module relations by site ID ---
export const listArrayModulesBySite = async (siteId) => {
  const { data } = await api.get(`/arraymodules/site/${siteId}`);
  return data;
};

// --- Get detailed array-module relations by site ID ---
export const listArrayModulesDetailedBySite = async (siteId) => {
  const { data } = await api.get(`/arraymodules/site/${siteId}/detailed`);
  return data;
};

// --- Create a new array-module relation ---
export const createArrayModule = async (payload) => {
  const { data } = await api.post("/arraymodules/", payload);
  return data;
};

// --- Update an array-module relation (PUT) ---
export const updateArrayModule = async (id, payload) => {
  const { data } = await api.put(`/arraymodules/${id}`, payload);
  return data;
};

// --- Delete an array-module relation ---
export const deleteArrayModule = async (id) => {
  const { data } = await api.delete(`/arraymodules/${id}/`);
  return data;
};

// --- Check if module can be deleted (safety check before delete) ---
export const canDeleteArrayModule = async (id) => {
  const { data } = await api.get(`/arraymodules/${id}/can_delete`);
  return data;
};

